import { useEffect } from 'react';
import {
    DEFAULT_DESCRIPTION,
    DEFAULT_TITLE,
    SITE_NAME,
    SITE_URL,
} from './siteConfig';

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

function upsertLink(rel, href) {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
}

/**
 * Updates document head for SPA routes (title, description, robots, canonical).
 */
function SeoHead({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
    path = '/',
    noIndex = false,
}) {
    useEffect(() => {
        const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
        document.title = fullTitle;

        const canonical = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
        const robots = noIndex
            ? 'noindex, nofollow'
            : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

        upsertMeta('name', 'description', description);
        upsertMeta('name', 'robots', robots);
        upsertMeta('name', 'googlebot', noIndex ? 'noindex, nofollow' : 'index, follow');
        upsertMeta('name', 'yandex', noIndex ? 'noindex, nofollow' : 'index, follow');
        upsertMeta('property', 'og:title', fullTitle);
        upsertMeta('property', 'og:description', description);
        upsertMeta('property', 'og:url', canonical);
        upsertLink('canonical', noIndex ? SITE_URL + '/' : canonical);
    }, [title, description, path, noIndex]);

    return null;
}

export default SeoHead;
